import { useEffect, useState, useMemo, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ProfileIcon from "../../../Assets/IconComponents/ProfileIcon";
import { errorToast } from "../../../../utils/toastHelper";
import ContactIcon from "../../../Assets/IconComponents/ContactIcon";
import ClientProfile from "./ClientProfile";
import ClientUsers from "./ClientUsers";
import ClientApi from "./ClientApi";
import { getApi } from "../../../../utils/services";
import { GET_CLIENT } from "../../../../utils/services/apiPath";
import ApprenticeshipOptions from "./ApprenticeshipOptions";
import { useTheme } from "../../../ContextStore/ThemeContext";
import { useDispatch, useSelector } from "react-redux";
import { handleLogout, userSelector } from "../../../store/features/auth/authSlice";
import logo from "../../../Assets/Icons/logo.png";
import logoWhite from "../../../Assets/Icons/logo-white.png";
import menuopen from "../../../Assets/Icons/menu-open.png";
import menuclose from "../../../Assets/Icons/menu-close.png";
import NotificationIcon from "../../../Assets/IconComponents/Notification";
import { headerMenus } from "../../../../utils/MenusConfig";
import HelpMenu from "../../../Components/Header/HelpMenu";
import { Layout, DetailPageLayout } from "@proscore-ai/proscore-ui-library";
import ClientRemainder from "./ClientRemainder";

export default function ClientDetail() {
  const { tab, id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("");
  const isAddMode = useMemo(() => id === "add", [id]);
  const [clientSubTitle, setClientSubTitle] = useState("");
  const { theme } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);
  const [popOverOpen, setPopOverOpen] = useState(false);
  const ref = useRef(null);
  const userData = useSelector(userSelector);
  const dispatch = useDispatch();
  const tabs = isAddMode
    ? [
        {
          to: "profile",
          title: "Profile",
          key: "profile",
          isActive: false,
          hasArrow: false,
          icon: ProfileIcon
        }
      ]
    : [
        {
          to: "profile",
          title: "Profile",
          key: "profile",
          isActive: false,
          hasArrow: false,
          icon: ProfileIcon
        },
        {
          to: "users",
          title: "Users",
          key: "users",
          isActive: false,
          hasArrow: false,
          icon: ContactIcon
        },
        {
          to: "apprenticeship-options",
          title: "Apprenticeship Options",
          key: "apprenticeship-options",
          isActive: false,
          hasArrow: false,
          icon: ContactIcon
        },
        {
          to: "api",
          title: "Api",
          key: "api",
          isActive: false,
          hasArrow: false,
          icon: ContactIcon
        },
        {
          to: "reminders",
          title: "Reminders",
          key: "reminders",
          isActive: false,
          hasArrow: false,
          icon: ContactIcon
        },
      ];

  const backAction = () => {
    navigate("/clients");
  };

  const handleTabClick = tab => {
    //navigate(`/clients/${id}/${tab.to}`);
    navigate(`${tab.to}`);
  };

  const handleTabInnerClick = tab => {
    navigate(`/clients/${id}/${tab.to}`);
  };

  const getClientProfileData = async id => {
    const { error, ...rest } = await getApi(`${GET_CLIENT}${id}`);
    if (error) return errorToast(error);
    setClientSubTitle(rest.companyName);
  };

  const handleMenuOpen = () => setMenuOpen(!menuOpen);

  const onLogout = () => {
    dispatch(handleLogout());
  };

  const manageAccount = () => {
    setPopOverOpen(false);
  };

  const handleHome = () => {
    navigate("/clients");
  };

  useEffect(() => {
    if (!isAddMode) getClientProfileData(id);
  }, [id]);

  useEffect(() => {
    const selectedTab = tabs.find(t => t.key === tab?.toLowerCase())?.title;
    setActiveTab(selectedTab || "Profile");
  }, [tab]);

  return (
    <Layout 
    theme={theme}
    user={{
      userName: userData?.userName,
      email: userData?.email,
      avatar: userData?.avatar
    }}
    onLogout={onLogout}
    onTabClick={handleTabClick}
    onLogoClick={handleHome}
    logo={logo}
    logoWhite={logoWhite}
    menuOpenIcon={menuopen}
    menuCloseIcon={menuclose}
    menuTabs={headerMenus}
    NotificationIcon={NotificationIcon}
    HelpComponent={HelpMenu}
    >
      {activeTab && (
        <DetailPageLayout
          backAction={backAction}
          tabs={tabs}
          title={isAddMode ? "ADD CLIENT" : "CLIENT INFORMATION"}
          subTitle={isAddMode ? "" : clientSubTitle}
          backLabel="Go back to Clients"
          activeTab={activeTab}
          handleTabClick={handleTabInnerClick}
        >
          {activeTab === "Profile" && <ClientProfile />}
          {activeTab === "Users" && <ClientUsers />}
          {activeTab === "Api" && <ClientApi />}
          {activeTab === "Apprenticeship Options" && <ApprenticeshipOptions />}
          {activeTab === "Reminders" && <ClientRemainder />}
        </DetailPageLayout>
      )}
    </Layout>
  );
}
